import { render, staticRenderFns } from "./DeckAppSettings.vue?vue&type=template&id=2f513fab&scoped=true"
import script from "./DeckAppSettings.vue?vue&type=script&lang=js"
export * from "./DeckAppSettings.vue?vue&type=script&lang=js"
import style0 from "./DeckAppSettings.vue?vue&type=style&index=0&id=2f513fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f513fab",
  null
  
)

export default component.exports